const barcodeUrl = (code, { download = false } = {}) => {
  const params = new URLSearchParams({ text: code });
  if (download) params.set("download", "1");
  return `/api/internal/barcode?${params.toString()}`;
};

export default barcodeUrl;
